import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Switch from 'react-toggle-switch';

const SwitchItem = (props) => {
	const {
		labelText, onChange, property, hasSeperator, notificationMethods,
	} = props;
	const emailSwitch = notificationMethods.find(({ MethodName }) => MethodName === 'Email');
	const smsSwitch = notificationMethods.find(({ MethodName }) => MethodName === 'SMS');

	return (
		<Fragment>
			<div className="flex">
				<div className="flex-3">
					{ labelText }
				</div>
				<div className="text-right flex-1 toggle-switch">
					<Switch
						className={emailSwitch.Customizable ? undefined : 'disabled'}
						on={emailSwitch.Enabled}
						enabled={emailSwitch.Customizable}
						onClick={() => onChange(property, 'Email')}
					/>
				</div>
				<div className="text-right flex-1 toggle-switch">
					<Switch
						className={smsSwitch.Customizable ? undefined : 'disabled'}
						on={smsSwitch.Enabled}
						enabled={smsSwitch.Customizable}
						onClick={() => onChange(property, 'SMS')}
					/>
				</div>
			</div>
			<If condition={hasSeperator}>
				<div className="separator separator-blue" />
			</If>
		</Fragment>
	);
};

SwitchItem.propTypes = {
	hasSeperator        : PropTypes.bool,
	labelText           : PropTypes.string.isRequired,
	notificationMethods : PropTypes.array,
	onChange            : PropTypes.func.isRequired,
	property            : PropTypes.number.isRequired,
};

SwitchItem.defaultProps = {
	hasSeperator        : true,
	notificationMethods : [],
};

export default SwitchItem;
